jQuery(document).ready(function($){ 
	var print_div = document.getElementById("lecture");
});